<script>
    import Button from "../Buttons/Button.svelte";

    export let onClick;
    export let selected;
</script>

<style lang="scss">
    @import "../../styles/_mixins.scss";

    div {
        width: 100vw;
        position: relative;
        left: 50%;
        right: 50%;
        margin-left: -50vw;
        margin-right: -50vw;
        display: flex;
        justify-content: center;
        z-index: 1;
        background-color: var(--color-white);
        position: fixed;
        bottom: 0;
        padding: var(--spacer-tiny) 0;

        :global(.platform) {
            margin-right: var(--spacer-medium);

            &:last-of-type {
                margin-right: 0;
            }
        }

        @include sm {
            width: max-content;
            max-width: 712px;
            margin: 0 auto;
            position: initial;
            border: none;
            padding: 0;
        }
    }
</style>

<div>
    <Button
        platform
        emoji="astronaut-f.svg"
        text="Profile"
        onClick={() => onClick('profile')}
        selected={selected === 'profile'} />
    <Button
        platform
        emoji="lightbulb.svg"
        text="Pitch"
        onClick={() => onClick('pitch')}
        selected={selected === 'idea'} />
    <Button
        platform
        emoji="matches.svg"
        text="Matches"
        onClick={() => onClick('matches')}
        selected={selected === 'matches'}
        disabled />
    <Button
        platform
        emoji="telescope.svg"
        text="Discover"
        onClick={() => onClick('discover')}
        selected={selected === 'discover'}
        disabled />
</div>
